import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useCallback, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function EmblaCarousel({ children }) {
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, speed: 10 });
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect(); // initial check
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", onSelect);
  }, [emblaApi, onSelect]);

  const scrollPrev = () => emblaApi?.scrollPrev();
  const scrollNext = () => emblaApi?.scrollNext();

  return (
    <div className="relative">
      {/* Viewport */}
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex touch-pan-x will-change-transform">{children}</div>
      </div>

      {/* Left Arrow */}
      <button
        onClick={scrollPrev}
        disabled={!canScrollPrev}
        className="absolute left-2 top-1/2 -translate-y-1/2 bg-white shadow-md hover:bg-gray-100 transition p-2 rounded-full disabled:opacity-30 z-10"
      >
        <ChevronLeft className="h-5 w-5 text-gray-600" />
      </button>

      {/* Right Arrow */}
      <button
        onClick={scrollNext}
        disabled={!canScrollNext}
        className="absolute right-2 top-1/2 -translate-y-1/2 bg-white shadow-md hover:bg-gray-100 transition p-2 rounded-full disabled:opacity-30 z-10"
      >
        <ChevronRight className="h-5 w-5 text-gray-600" />
      </button>
    </div>
  );
}
